/**
 * Portfolio tabs: filter project cards by metaobject "type" handles.
 */
(function () {
	if (customElements.get('page-projects-portfolio')) return;

	class PageProjectsPortfolio extends HTMLElement {
		connectedCallback() {
			this.buttons = this.querySelectorAll('[data-projects-filter]');
			this.items = this.querySelectorAll('[data-project-item]');
			if (!this.buttons.length || !this.items.length) return;

			this.buttons.forEach((btn) => {
				btn.addEventListener('click', () => this.setFilter(btn.dataset.projectsFilter || 'all'));
			});

			const initial = this.querySelector('[data-projects-filter].is-active');
			this.setFilter(initial ? initial.dataset.projectsFilter : 'all', false);

			if (Shopify.designMode) {
				this.addEventListener('shopify:section:load', () => {
					const a = this.querySelector('[data-projects-filter].is-active');
					this.setFilter(a ? a.dataset.projectsFilter : 'all', false);
				});
			}
		}

		setFilter(filter, focus = true) {
			const f = (filter || 'all').toLowerCase();
			this.buttons.forEach((btn) => {
				const active = (btn.dataset.projectsFilter || 'all').toLowerCase() === f;
				btn.classList.toggle('is-active', active);
				btn.setAttribute('aria-selected', active ? 'true' : 'false');
				if (active && focus) btn.focus();
			});
			this.items.forEach((item) => {
				const raw = item.getAttribute('data-project-types') || '';
				const types = raw.split(/\s+/).filter(Boolean);
				const show = f === 'all' || types.includes(f);
				item.toggleAttribute('hidden', !show);
				item.classList.toggle('is-visible', show);
			});
		}
	}

	customElements.define('page-projects-portfolio', PageProjectsPortfolio);
})();
